export const kWeekInMilliseconds = 1000 * 60 * 60 * 24 * 7;

// -----------------------------------------------------------------------------
export class Utils {
  // ---------------------------------------------------------------------------
  public static deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj)) as T;
  }

  // ---------------------------------------------------------------------------
  public static randomWholeNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  // ---------------------------------------------------------------------------
  // TODO(twolf): Consider a TimeCalcService
  public static calcTimePassedInWeeks(timestamp: number) {
    if (timestamp === 0) {
      return 0;
    }

    return (Date.now() - timestamp) / kWeekInMilliseconds;
  }
}
